import { NgModule } from '@angular/core';

import { DesktopSwipeDirective } from './desktopSwipe.directive';

@NgModule({
  exports: [DesktopSwipeDirective],
  declarations: [DesktopSwipeDirective],
})
export class DesktopSwipeModule {
}